import { render, staticRenderFns } from "./BlackBoxComponent.vue?vue&type=template&id=4ffeb4a9&scoped=true"
import script from "./BlackBoxComponent.vue?vue&type=script&lang=js"
export * from "./BlackBoxComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffeb4a9",
  null
  
)

export default component.exports